import { Button, DuplicateIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDuplicateFontCollection } from "../../../hooks/libraries/fontCollections/useDuplicateFontCollection";

type FontCollectionDuplicateButtonProps = {
  fontCollectionId: string;
};

export const FontCollectionDuplicateButton: React.FC<
  FontCollectionDuplicateButtonProps
> = ({ fontCollectionId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [duplicateFontCollection, isLoading] =
    useDuplicateFontCollection(fontCollectionId);

  return (
    <Button
      key="font-collection-duplicate"
      icon={<DuplicateIcon />}
      onClick={async () => {
        const fontCollection = await duplicateFontCollection();

        if (fontCollection) {
          navigate(
            `/libraries/font-collections/embroidery/${fontCollection.id}`
          );
        }
      }}
      loading={isLoading}
    >
      {t("font_collections.actions.duplicate.button")}
    </Button>
  );
};
